import 'stacktable.js/stacktable.js';

(function($, Drupal) {
  'use strict';

  Drupal.behaviors.stacktable = {
    attach: function(context, settings) {
      let $body_field = $('.field--name-body');
      if ($body_field) {
        let $tables = $('.field--name-body', context).find('table');
        let $empty_cells = $tables.find('th');

        $empty_cells.html(function(i, html) {
          return html.replace(/&nbsp;/g, '');
        });

        $tables.once('alter-tables').each(function(index) {
          // Find all 'repsonsive tables' and add id's
          $(this).attr('id', 'responsive-table-' + index);
          $('#responsive-table-' + index).cardtable();
        });
      }
    }
  };
})(jQuery, Drupal);
